class ContactModel
{
    constructor (obj?: ContactModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Id?: number;
    
    public CustomerNumber?: number;
    
    public Company?: string;
    
    public Code?: string;
    
    public RoundTripMileage?: number;
    
    public ContactInformation?: string;

    public Status?: number;
    
    public Phone?: string;
}

class ClientModel extends ContactModel
{
    // ... alias 
}

export { ContactModel, ClientModel }